import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useCallback, useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import SearchBoxModal from "../component/SearchBoxModal";
import AlertErrorForm from "../component/AlertErrorForm";
import {
    isCustomTemplateParam,
    normalizeParamTitle,
    parseContractParams,
    toPlaceholder,
} from "./contractParams";
import PreviewFile from "./PreviewFile";

export default function FormHopDong() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams(); const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [listParam, setListParam] = useState([])
    const [listMauParam, setListMauParam] = useState([])
    const [detailMau, setDetailMau] = useState()
    const [paramTitle, setParamTitle] = useState('')
    const [paramValue, setParamValue] = useState('')
    const defaultdetail = {
        title: '',
        type_id: '',
        luong: '',
        params: '',
        user_id: '',
        author_id: user.data.id,
        status: 1,
    }

    const loadMauHD = useCallback((typeid) => {
        Axios.get(URL_LIST_ALL + "hopdong_type/" + typeid, user.config).then(async (res) => {
            if (res.data.status === "success") {
                const templateParams = parseContractParams(res.data.data.params)
                setListMauParam(templateParams)
                setDetailMau(res.data.data)
                const customTemplateParams = templateParams.filter(isCustomTemplateParam)
                if (customTemplateParams.length > 0) {
                    setListParam((currentParams) => {
                        const cloneParams = currentParams.slice()
                        customTemplateParams.forEach((item) => {
                            const key = toPlaceholder(item.title)
                            if (normalizeParamTitle(key) && !cloneParams.find((param) => normalizeParamTitle(param.key) === normalizeParamTitle(key))) {
                                cloneParams.push({ key: key, value: '' })
                            }
                        })
                        return cloneParams
                    })
                }
            } else console.log(res.data.message);
        }).catch((err) => console.log(err));
    }, [user.config])

    useEffect(function () {
        if (id > 0) {
            Axios.get(URL_LIST_ALL + "hopdong/" + id, user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        let detail = res.data.data
                        setDetail(detail);
                        loadMauHD(detail.type_id)
                        setListParam(parseContractParams(detail.params))
                    } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
        }
    }, [user.config, id, loadMauHD]);


    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Vui lòng nhập tên văn bản hợp đồng').max(200, "Độ dài không quá 200 ký tự"),
            user_id: Yup.string().trim().nullable().required('Vui lòng chọn đối tượng'),
            type_id: Yup.string().trim().nullable().required('Vui lòng chọn mẫu hợp đồng'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            values.status = 0
            setLoading(true)
            values.params = JSON.stringify(listParam)
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'hopdong/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật mẫu hợp đồng thành công',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    window.location.href = "/edit-hop-dong/" + id
                                },
                            }
                            ]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'hopdong', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới mẫu hợp đồng thành công',
                            buttons: [{
                                label: 'OK', onClick: () => {
                                    window.location.href = "/edit-hop-dong/" + res.data.id
                                },
                            }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const addParams = () => {
        const title = normalizeParamTitle(paramTitle)
        if (title && paramValue && title !== '' && paramValue !== '') {
            let newList = listParam.slice()
            newList.push({ key: toPlaceholder(title), value: paramValue })
            setListParam(newList)
            setParamTitle('')
            setParamValue('')
        }
    }
    const deleteParam = (key) => {
        let newList = listParam.slice()
        newList.splice(key, 1)
        setListParam(newList)
    }

    const editParams = (i, type, value) => {
        let cloneParams = listParam.slice()
        cloneParams[i][type] = type === 'key' ? toPlaceholder(value) : value
        setListParam(cloneParams)
    }

    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/hop-dong">Danh sách Văn bản, Hợp đồng</Link>
                    </li>
                    <li>{id ? 'Cập nhật Văn bản, Hợp đồng' : 'Thêm mới Văn bản, Hợp đồng'}</li>
                </ul>
            </div>
            <div className="card height-auto">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Quản lý Văn bản, Hợp đồng</h3>
                        </div>
                    </div>

                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-sm-4 col-12 form-group">
                                <label>Tên văn bản - hợp đồng <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>

                            <div className="col-sm-4 col-12 form-group">
                                <label>Đối tượng sử dụng </label>
                                <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'fullname'} defaultValue={formik.values['user_id']} name='user_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('user_id', e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="user_id"></AlertErrorForm>
                            </div>

                            <div className="col-12"></div>

                            <div className="col-sm-4 col-12 form-group">
                                <label>Chọn mẫu văn bản - hợp đồng </label>
                                <SearchBoxModal apiname={"hopdong_type"} placeholder="Chọn văn bản/hợp đồng" colvalue={'id'} colname={'title'} defaultValue={formik.values['type_id']} name='type_id'
                                    onChange={async (e) => {
                                        await formik.setFieldValue('type_id', e)
                                        loadMauHD(e)
                                    }}></SearchBoxModal>
                                <AlertErrorForm formik={formik} name="type_id"></AlertErrorForm>
                            </div>
                            {detailMau && detailMau.urlfile &&
                                <div className="col-12 col-sm-4 form-group">
                                    <label>Xem mẫu văn bản - hợp đồng</label>
                                    <PreviewFile
                                        isEdit={false}
                                        detail={{ list_file: (() => { try { return JSON.parse(detailMau.urlfile); } catch(e) { return [detailMau.urlfile]; } })() }}
                                    />
                                </div>
                            }

                            <div className="col-12"></div>
                           
                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-sm-12 col-12 form-group">
                                <label>Tham số trong văn bản Mẫu</label>
                                {listMauParam.length > 0 &&
                                    <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                        {listMauParam.map((k, i) => {
                                            const isCustom = isCustomTemplateParam(k)
                                            const label = k.label || k.value || k.title
                                            return (<span
                                                key={i}
                                                className={'border rounded px-2 py-1 ' + (isCustom ? 'bg-warning bg-opacity-10 border-warning' : 'bg-light')}
                                                title={isCustom ? 'Tùy biến nhập khi tạo hợp đồng' : 'Hệ thống tự merge'}
                                            >
                                                <span>{label}: </span>
                                                <code>{toPlaceholder(k.title)}</code>
                                            </span>)
                                        })}
                                    </div>
                                }
                            </div>
                            <div className="col-12 mt-3" ><hr /></div>
                            <div className="col-sm-12 col-12 form-group">
                                <label>Thêm tham số tùy biến ngoài mẫu</label>
                                <div className="row">
                                    <div className="col-4 form-group">
                                        <input type="text" placeholder="Tên tham số, ví dụ NGUOIKY" className="form-control " onChange={(e) => setParamTitle(e.target.value)} autoComplete="off" value={paramTitle} />
                                    </div>
                                    <div className="col-4 form-group">
                                        <textarea className="form-control" placeholder="Dữ liệu" onChange={(e) => setParamValue(e.target.value)} value={paramValue} ></textarea>
                                    </div>
                                    <div className="col-4 form-group">
                                        <button type="button" className="btn btn-sm btn-info height32" onClick={() => addParams()}>Thêm</button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-12 form-group">
                                {listParam && listParam.length > 0 && <>
                                    <label>Giá trị tham số tùy biến</label>
                                    <div className="row">
                                        {listParam.map((k, i) => {
                                            return (<div className="col-12 mb-3" key={i}>
                                                <div className="row">
                                                    <div className="col-5">
                                                        <input type='text' className="form-control height32" value={k.key || ''} onChange={(e) => editParams(i, 'key', e.target.value)} />
                                                        <small><code>{toPlaceholder(k.key || '')}</code></small>
                                                    </div>
                                                    <div className="col-5">
                                                        <input type='text' className="form-control height32" value={k.value || ''} onChange={(e) => editParams(i, 'value', e.target.value)} />
                                                    </div>
                                                    <div className="col-2">
                                                        <button type="button" className="btn btn-sm btn-danger" onClick={() => deleteParam(i)}>Xóa</button>
                                                    </div>
                                                </div>
                                            </div>)
                                        })}
                                    </div>
                                </>
                                }
                            </div>
                            {detail && detail.file_url &&
                                <div className="col-12 col-sm-4 form-group mg-t-8">
                                    <label>File hợp đồng đã merge</label>
                                    <PreviewFile
                                        isEdit={false}
                                        detail={{ list_file: [detail.file_url] }}
                                    />
                                </div>
                            }

                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </AkkhorLayout>
    );
}
